import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d6cd43e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewCalendar__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M20.1857 11V13H8.1857L13.6857 18.5L12.2657 19.92L4.3457 12L12.2657 4.07996L13.6857 5.49996L8.1857 11H20.1857Z",
  fill: "#BFC5D9"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "header__current" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3.99984 11V13H15.9998L10.4998 18.5L11.9198 19.92L19.8398 12L11.9198 4.07996L10.4998 5.49996L15.9998 11H3.99984Z",
  fill: "#BFC5D9"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "NewCalendar__container" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"container__days\" data-v-8d6cd43e><div class=\"days__day\" data-v-8d6cd43e>Пн</div><div class=\"days__day\" data-v-8d6cd43e>Вт</div><div class=\"days__day\" data-v-8d6cd43e>Ср</div><div class=\"days__day\" data-v-8d6cd43e>Чт</div><div class=\"days__day\" data-v-8d6cd43e>Пт</div><div class=\"days__day\" data-v-8d6cd43e>Сб</div><div class=\"days__day\" data-v-8d6cd43e>Вс</div></div>", 1)
const _hoisted_9 = { class: "container__dates" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "NewCalendar__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["NewCalendar", { 'NewCalendar--disabled': _ctx.disabled, 'NewCalendar--range': _ctx.range }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPreviousMonth && _ctx.onPreviousMonth(...args)))
      }, _hoisted_3)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getCurrentMonthYear()), 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNextMonth && _ctx.onNextMonth(...args)))
      }, _hoisted_6))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `calendar-date-${i}`,
            class: _normalizeClass(["dates__date", {
                        'date--weekend': _ctx.isWeekend(date),
                        'date--today': _ctx.isDateToday(date),
                        'date--in-range': _ctx.isDateInRange(date),
                        'date--selected': _ctx.isDateSelected(date),
                        'date--disabled': _ctx.isDateDisabled(date),
                    }])
          }, [
            _createElementVNode("div", {
              class: "date__content",
              onClick: ($event: any) => (_ctx.onSelectDate(date))
            }, _toDisplayString(date.getDate()), 9, _hoisted_10)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_new_button, {
        class: "NewButton--reset",
        disabled: _ctx.disabled,
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _createTextVNode("Сбросить")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ], 2))
}